const navbarMiddle = [
  { title: 'Categorías' },
  { title: 'Ofertas' },
  { title: 'Historial' },
  { title: 'Supermercado' },
  { title: 'Moda' },
  { title: 'Vender' },
  { title: 'Ayuda' },
]

const footer = [
  {
    title: 'Trabajá con nosotros',
    url: 'https://careers-meli.mercadolibre.com/?utm_campaign=site-mla&utm_source=mercadolibre&utm_medium=mercadolibre'
  },
  {
    title: 'Términos y condiciones',
    url: 'https://www.mercadolibre.com.ar/ayuda/terminos-y-condiciones-de-uso_991'
  },
  {
    title: 'Cómo cuidamos tu privacidad',
    url: 'https://www.mercadolibre.com.ar/privacidad'
  },
  {
    title: 'Accesibilidad',
    url: 'https://www.mercadolibre.com.ar/accesibilidad'
  },
  {
    title: 'Información al usuario financiero',
    url: 'https://www.mercadolibre.com.ar/ayuda/18697'
  },
  {
    title: 'Ayuda',
    url: 'https://www.mercadolibre.com.ar/ayuda'
  },
  {
    title: 'Defensa al consumidor',
    url: 'https://www.mercadolibre.com.ar/ayuda/Defensa-del-Consumidor_s20014'
  },
  {
    title: 'Información sobre seguros',
    url: 'https://www.mercadolibre.com.ar/ayuda/23303'
  },
]

export {
  footer,
  navbarMiddle
}